
import { requiredItem, numberRequired } from "@/assets/js/formRules";
const DAYTIME = 24 * 3600 * 1000;
export default {

  data() {
    const nameFormRules = {
      year: [
        {
          validator: (rule, value, callback) => {
            if (this.nameData.ifCustom) {
              callback();
            } else {
              if (!value) {
                callback(new Error("请选择年份"));
              } else {
                callback();
              }
            }
          },
          trigger: "change",
        },
      ],
      custom: [
        {
          validator: (rule, value, callback) => {
            if (this.nameData.ifCustom) {
              if (!value) {
                callback(new Error("请填写报名名称"));
              } else {
                if (value.length > 50) {
                  callback(new Error("请输入50以内的字符"));
                } else {
                  callback();
                }
              }
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      ],
    };
    return {
      nameFormRules,
      formDataRules: {
        transfer_item_name: [ requiredItem('名称') ],
        coach_submit: [ requiredItem('教练员注册申请窗口期')],
        leave_org_audit_end: [ requiredItem('转出协会审核截止日期')],
        enter_org_audit_end: [ requiredItem('转入协会审核截止日期')],
        is_need_work: [ requiredItem('在职证明')],
        is_need_live_proof: [ requiredItem('居住证明')],
        transfer_item_linkman: [ requiredItem('联系人')],
        is_need_reason: [ requiredItem('变更注册协会原因')],
      },



    }
  },

  computed: {
    yearOpt() {
      return {
        disabledDate: (time) => {
          return time.getFullYear() < new Date().getFullYear();
        },
      };
    },

    opsForCoachSubmit() {
      const { enter_org_audit_end, leave_org_audit_end } = this.formData;
      return {
        disabledDate: function(time) {
          if(enter_org_audit_end && leave_org_audit_end) {
            const timeFlag = time.getTime() > enter_org_audit_end || time.getTime() > leave_org_audit_end || time.getTime() < new Date().getTime() - DAYTIME;
            return timeFlag;
          } else if(enter_org_audit_end) {
            const timeFlag = time.getTime() > enter_org_audit_end || time.getTime() < new Date().getTime() - DAYTIME;
            return timeFlag;
          } else if(leave_org_audit_end) {
            const timeFlag = time.getTime() > leave_org_audit_end || time.getTime() < new Date().getTime() - DAYTIME;
            return timeFlag;
          } else {
            return time.getTime() <= new Date().getTime() - DAYTIME;
          }
        }
      }
    },

    opsForEnterOrgAudit() {
      const { coach_submit, leave_org_audit_end } = this.formData;
      const [ coach_submit_start, coach_submit_end ] = coach_submit || [];
      return {
        disabledDate: function(time) {
          if(coach_submit_end && leave_org_audit_end) {
            const timeFlag = time.getTime() < coach_submit_end + DAYTIME ||  time.getTime() > leave_org_audit_end - DAYTIME;
            return timeFlag;
          } else if(coach_submit_end) {
            const timeFlag = time.getTime() < coach_submit_end + DAYTIME;
            return timeFlag;
          } else if(leave_org_audit_end) {
            const timeFlag = time.getTime() > leave_org_audit_end + DAYTIME;
            return timeFlag
          } else {
            return time.getTime() <= new Date().getTime() - DAYTIME;
          }
        }
      }
    },

    opsForLeaveOrgAudit() {
      const { coach_submit,enter_org_audit_end } = this.formData;
      const [ coach_submit_start, coach_submit_end ] = coach_submit || [];
      return {
        disabledDate: function(time) {
          if(coach_submit_end && enter_org_audit_end){
            return time.getTime() <= new Date().getTime() - DAYTIME || time.getTime() < coach_submit_end + DAYTIME || time.getTime() < enter_org_audit_end + DAYTIME;
          }
          if(coach_submit_end) {
            return time.getTime() <= new Date().getTime() - DAYTIME || time.getTime() < coach_submit_end + DAYTIME
          }
          if(enter_org_audit_end) {
            return time.getTime() <= new Date().getTime() - DAYTIME || time.getTime() < enter_org_audit_end + DAYTIME
          }
          return time.getTime() <= new Date().getTime() - DAYTIME
        }
      }
    },
  },


}
